
import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import InputHote from './InputHote'
import { useEffect, useState} from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Typography,
} from "@material-tailwind/react";
import { useTranslation } from 'react-i18next';
import { SearchContext } from '../../../SearchContext';

import { toast, ToastContainer } from 'react-toastify';
import { ResultContext } from '../../../ResultContext';

 

function BarreSearchP({ cde }: { cde: any }) {

  interface CityCI {
    name : string,
  }

  let fd = new FormData();

  
  const [open, setOpen] = React.useState(false);
 
  const handleOpen = () => setOpen(!open);
  
 // const [age, setAge] = React.useState('');
  const [arrivalDate, setArrivalDate] = useState(null);
  const [departureDate, setDepartureDate] = useState(null);
  
  const navigate = useNavigate();
  const [cityCi, setCityCi] = useState<CityCI[]>([]);


  //const [adults, setAdults] = useState(0);
  //const [children, setChildren] = useState(0);
  //const [nbPlace, setNbPlace] = useState(0);

  const {nbPlace ,updateNbre,age,updateAge,arrivDate,departDate,adult=1,child=0,updateArrival,updateDepart,updateChild,updateAdult} = React.useContext(SearchContext)
  const contexts = React.useContext(ResultContext)
  interface DataSearching {
    destination?:string | null,
    departure_date?:string | null,
    arrival_date?:string | null
    
  }

  const handleArrivalDateChange = (date: any) => {
    updateArrival(date);
  };

  const handleDepartureDateChange = (date: any) => {
    updateDepart(date);
  };
  const handleAdultsChange = (event: any) => {
    updateAdult(parseInt(event.target.value, 10) ?? 1);
  };
  
  const handleChildrenChange = (event: any) => {
    updateChild(parseInt(event.target.value, 10));
  };

  const handleValidate = () => {
    // Passez des valeurs valides pour adult et child
    updateNbre(adult, child);
    // Effectuez les actions nécessaires avec les données saisies
    handleOpen(); // Ferme le popup après validation
}

 
  const handleSearch = (event : any) => {
    event.preventDefault();
    toast.success("Recherche  effectuée avec succes. Defilez pour voir les resultats de la recherche");
    const formattedArrivalDate = arrivDate ? dayjs(arrivDate).format('YYYY-MM-DD') : null;
    const formattedDepartureDate = departDate ? dayjs(departDate).format('YYYY-MM-DD') : null;
  
    if (age){
     // console.log("votre destination est "+ age)
      fd.append("destination", age);
    }
    
    if (formattedArrivalDate) {
      //console.log("votre heure d'arriver  est "+ formattedArrivalDate)
      fd.append("dateArr", formattedArrivalDate);
    }
    
    if (formattedDepartureDate) {
     // console.log("votre heure d'arriver  est "+ formattedDepartureDate)
      fd.append("dateDep", formattedDepartureDate);
    }
    
    if (nbPlace){
     // console.log("votre heure d'arriver  est "+ nbPlace)
      fd.append("place", nbPlace.toString());
    }

   


    //console.log("Les information de recherche sont ",fd)

    //console.log(dateDep)

    // Fonction asynchrone pour envoyer les données au backend
    const sendSearchData = async () => {
     
      try {
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/get/info/search/annonce`, fd, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        
         if(response.data[0].length === 0)
         {
          toast.success("Aucun resultat n'a ete trouver pour votre recherche")
          return;
         }

        //console.log(response.data); 
        // Vérifiez la structure de la réponse

        const data = response.data[0];
        if (!data) {
        throw new Error("Data is undefined");
        }
        contexts?.updateResults ({
        hebergement: data.hebergement,
        resto: data.resto,
        voiture: data.voiture,
        loisire: data.loisire,
        culture: data.culture,
        });


        // const dataSearching: DataSearching = {
        //   destination:age,
        //   departure_date:departureDate,
        //   arrival_date:arrivalDate
        // }
        //envoie des résultats sur les page recherche
        //navigate('/SearchB_ResultPage', { state: { results: response.data[0] } }) // Navigate to results page
        //window.location.reload();
    } catch (err) {
        console.log(err);
      }
    };
  
    sendSearchData();
  };

  const handleChange = (event: SelectChangeEvent) => {
    //setAge(event.target.value as string);
    updateAge(event.target.value as string)
  };

  //city of CI
  async function getCityOfCI(){
    let code:string | null = localStorage.getItem('code') || cde;
     
    

    try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/get/city/of/ci`,{
          params:  {code}
        })
        //console.log(response.data)
        setCityCi(response.data.data)
    }catch (err) {
        console.log(err);
    }
    // finally {
    //     setLoadingCategoryItem(false);
    // }
    
  }
  useEffect(() => {
      getCityOfCI()
      fd.append("place",String(1))
  }, []);
 

  const {t} = useTranslation() as {t:(key:string)=>string}

  useEffect(()=>{
     console.log(nbPlace)
  },[nbPlace])

 // const {destination,arrivDate,departDate,adult,child} = React.useContext(SearchContext)
  
  return (
    <div className=''>
      
      <ToastContainer/>
      <div className='barreSearch bg-sky-950   s:py-5 md:h-24  s:h-full xs:w-[600px] md:w-full grid s:grid-cols-1 xs:grid-cols-2 md:grid-cols-5 gap-4 items-center  px-10 rounded-lg  '>

        {/* Destination */}
      
          <Box className=" s:w-[200px]  md:w-52 h-14 pt-[4px]"  sx={{ }}>
            <FormControl fullWidth className="bg-white rounded-md sm:w-60 s:w-40 xs:w-96 md:w-52 h-14 pb-6">
            <InputLabel 
                id="demo-simple-select-label" 
                shrink={age !== ""}  // Étiquette rétrécie lorsque une option est sélectionnée
                sx={{
                  '&.MuiInputLabel-shrink': {
                    transform: 'translateY(-2px) scale(0.85) translateX(20px)',  
                  },
                }}
              >
                {t("Destination")}
              </InputLabel>
              <Select 
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={age || ''}
                label="Age"
                onChange={handleChange}
              >
                {cityCi ? cityCi.map((option, index: any) => (        
                  <MenuItem key={index} className="sm:w-60 s:w-40 xs:w-96 md:w-52" value={option?.name}>{option?.name}</MenuItem>
                )): ""}
              </Select>
            </FormControl>
          </Box>

        {/* arrivée */}
       
        {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={['DatePicker']}>
            <DatePicker
              label={t("Arrivée")}
              value={arrivDate || ''}
              onChange={handleArrivalDateChange}
              className='px-5 bg-white rounded-md outline-none s:w-20 md:w-52 h-14'

               sx={{
              '& .MuiInputLabel-root': {
                // Vous pouvez ajuster ici la transformation pour l'étiquette
                transform: arrivDate ? 'translateY(-2px) scale(0.85) translateX(20px)' : 'translateY(10px) translateX(20px) scale(1)',
                transition: 'transform 0.2s ease',
              },
              '& .MuiOutlinedInput-root': {
                // Styles personnalisés pour l'input lui-même
                '& fieldset': {
                  borderColor: 'grey', // Exemple de personnalisation de la bordure
                },
              },
            }}
             
            />
          </DemoContainer>
        </LocalizationProvider> */}

        <LocalizationProvider dateAdapter={AdapterDayjs} >
          <DemoContainer components={['DatePicker'] } >
            <DatePicker label="Arrivée" className='px-5 bg-white rounded-md outline-none s:w-20 md:w-52 h-14' 
            value={arrivDate  } 
            onChange={handleArrivalDateChange}
           
            />
          </DemoContainer>
        </LocalizationProvider>


        {/* Depart */}
        {/* <LocalizationProvider dateAdapter={AdapterDayjs} >
          <DemoContainer components={['DatePicker'] } >
            <DatePicker 
            label={t("Départ")} className='px-5 bg-white rounded-md outline-none s:w-40 md:w-52 h-14'
            value={departDate || ''} 
            onChange={handleDepartureDateChange}
            sx={{
              '& .MuiInputLabel-root': {
                // Vous pouvez ajuster ici la transformation pour l'étiquette
                transform: departDate ? 'translateY(-2px) scale(0.85) translateX(20px)' : 'translateY(10px) translateX(20px) scale(1)',
                transition: 'transform 0.2s ease',
              },
              '& .MuiOutlinedInput-root': {
                // Styles personnalisés pour l'input lui-même
                '& fieldset': {
                  borderColor: 'grey', // Exemple de personnalisation de la bordure
                },
              },
            }}
             />
          </DemoContainer>
        </LocalizationProvider> */}

        <LocalizationProvider dateAdapter={AdapterDayjs} >
          <DemoContainer components={['DatePicker'] } >
            <DatePicker label="Départ" className='px-5 bg-white rounded-md outline-none s:w-40 md:w-52 h-14'
            value={departDate} 
            onChange={handleDepartureDateChange} 
           
            />
          </DemoContainer>
        </LocalizationProvider>

        {/* Hote */}
       <div className='pt-[4px]'>
          {/* <InputHote /> */}
            <div 
                onClick={handleOpen} 
                className="s:w-[200px] md:w-52 h-14 bg-white text-gray-500 px-5 rounded-md flex items-center justify-center cursor-pointer hover:cursor-pointer"
              >
              {t("Hotes")} ({`${adult || 1} adult(s), ${child || 0} kid(s)`})


            </div>

          {/* <div onClick={handleOpen} className=" s:w-[200px]  md:w-52 h-14 bg-white px-5 rounded-md">{t("Hotes")}</div> */}
       </div>
        {/* search */}
            <button className='bg_search_p h-12  s:w-[200px] md:w-40 rounded-md' onClick={handleSearch}>
                {t("Recherche")}
            </button>

      </div>

    
      <Dialog open={open} className="w-full sm:w-[300px] " handler={handleOpen}>
        <div className="flex items-center justify-between">
          <DialogHeader className="flex flex-col items-start">
            <Typography className="mb-1" variant="h5">
              Sélectionnez les hôtes
            </Typography>
          </DialogHeader>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-5 h-5 mr-3 cursor-pointer"
            onClick={handleOpen}
          >
            <path
              fillRule="evenodd"
              d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <DialogBody>
          <div className="grid gap-6">
            <p className="font-semibold">Nombre Adultes </p>
            <input
              type="number"
              //min="1" 
              className="rounded w-full"
              value={adult}
              onChange={handleAdultsChange}
            />
          </div>
          <div className="grid gap-6 mt-3">
            <p className="font-semibold">Nombre Enfants </p>
            <input
              type="number"
              min="0"
              className="rounded w-full"
              value={child}
              onChange={handleChildrenChange}
            />
          </div>
        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="text" className="bg-[#233D4D] text-white" onClick={handleOpen}>
            Annuler
          </Button>
          <Button variant="gradient" className="bg-[#fe7f2d]" onClick={handleValidate}>
            Valider
          </Button>
        </DialogFooter>
    </Dialog>

      
    </div>
  )
}


export default BarreSearchP
